import { FC } from "react"
import { Trans, useTranslation } from "react-i18next"
import moment from "moment-timezone"

import { formatCurrencyWithDecimals } from "../../../core/utils/formatters"
import { UText } from "../../../ui-component"
import { Box, Grid, Paper } from "../../../ui-component/mui.components"
import { Alert, Link } from "@mui/material"

export const OutstandingBalance: FC<{ outstandingBalance: number }> = ({
  outstandingBalance,
}) => {
  const { t } = useTranslation("common")

  const getPreviousMonth = (): string => {
    const previousMonth = moment().subtract(1, "months").format("MMMM YYYY")
    return previousMonth
  }

  return (
    <Grid item container justifyContent={"center"}>
      <Alert
        sx={{ borderRadius: 2, width: "100%", mx: 4, marginBottom: 2 }}
        severity={"info"}
      >
        <Trans
          components={{
            settingsPageLink: (
              <Link
                href={"/settings/userProfile"}
              />
            ),
          }}
        >
          {"billingHistory.creditcardonfile"}
        </Trans>
      </Alert>
      <Paper
        elevation={0}
        sx={{ borderRadius: 2, width: "100%", mx: 4, minHeight: "100px" }}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"start"}
          pb={2}
          ml={4}
        >
          <UText variant={"h6"} sxProp={{ pt: 2, pb: 2, fontWeight: "600" }}>
            {t("billingHistory.outstandingBalance")}
          </UText>
          <UText variant={"body1"}>
            {t("billingHistory.amountdue") + " "}
            {getPreviousMonth()}
          </UText>
          {outstandingBalance ? (
            <UText variant={"body1"} sxProp={{ pb: 2, pt: 1, fontWeight: 700 }}>
              {formatCurrencyWithDecimals(outstandingBalance)}
            </UText>
          ) : null}
        </Box>
      </Paper>
    </Grid>
  )
}
